export enum TransferMethodsEnum {
  MANUAL = 'manual',
  SEPA_DIRECT_DEBIT = 'sepa_direct_debit',
}
